import Lottie from "lottie-react";
import animationData from "../../assets/animations/404Animation.json";
import { Link } from "react-router-dom";

const AuthenticatedErrorPage = () => {
  document.title = "Page not found - Mosquepay";
  
  return (
    <div>
      <div className="flex justify-center items-center px-4">
        <div className="lg:w-2/5">
          <div className="flex justify-center w-full">
            <Lottie
              animationData={animationData}
              loop={true}
              className="w-60"
            />
          </div>
          <div>
            <p className="font-bold text-center mb-2">
              Page not found!
            </p>
            <p className="text-center">
              It looks like the page you're looking for doesn't exist or was
              moved. Check if your web address is correct or go back to your
              <Link to={"/dashboard"} className="text-brandGreen underline font-medium ps-1">
                dashboard
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthenticatedErrorPage;
